import React from 'react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {insight} from '../../icons';
import {ITranslate} from '../../../../../services/LocalizationService';
import {observer} from 'mobx-react';

interface ScanResultInsightsProps {
    text: string;
    translate: ITranslate;
    isOpen?: boolean;
    setIsInsightsOpen: (label: boolean) => void;
}

const maxHeightText = 129;
const maxMidHeightText = 130;
const midHeightText = 92;
const minHeightText = 50;

function getMinHeightByHeight(height: number): string {
    if (height >= maxHeightText) {
        return 'min-140';
    }
    if (height > midHeightText && height <= maxMidHeightText) {
        return 'min-110';
    }
    if (height > minHeightText && height <= midHeightText) {
        return 'min-90';
    }

    return '';
}

@observer
export class ScanResultInsights extends TechseeBaseComponent<ScanResultInsightsProps> {
    renderInternal() {
        const {text, translate, isOpen, setIsInsightsOpen} = this.props;
        const openTextBox = text.length > maxHeightText && isOpen;

        return (
            <div
                className={`scan-result-insight-container ${openTextBox ? 'open' : ''} ${getMinHeightByHeight(text.length)}`}>
                <div className={`scan-result-insight-content ${openTextBox ? 'open' : ''}`}>
                    <div className={'insights-icon'}> {insight}</div>
                    <div
                        onClick={() => setIsInsightsOpen(!isOpen)}
                        className={`scan-result-insight-wrapper ${isOpen ? 'open' : ''}`}>
                        <h2>{translate('CONNECTIVITY_GURU.WIFI_SCAN.INSIGHTS')}</h2>
                        <p>{text}</p>
                    </div>
                </div>
            </div>
        );
    }
}
